import { render, staticRenderFns } from "./reportDetailMulit.vue?vue&type=template&id=064a426e&scoped=true"
import script from "./reportDetailMulit.vue?vue&type=script&lang=js"
export * from "./reportDetailMulit.vue?vue&type=script&lang=js"
import style0 from "./reportDetailMulit.vue?vue&type=style&index=0&id=064a426e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a426e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064a426e')) {
      api.createRecord('064a426e', component.options)
    } else {
      api.reload('064a426e', component.options)
    }
    module.hot.accept("./reportDetailMulit.vue?vue&type=template&id=064a426e&scoped=true", function () {
      api.rerender('064a426e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/reportDetailMulit.vue"
export default component.exports